import Axios from 'axios';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
} from '@material-ui/core';
import {
  CloudUpload as FinalProjectUploadIcon,
  CompareArrows as CollaborateIcon,
  ExploreOutlined as TeacherResourcesIcon,
  BuildOutlined as FixIcon,
  MoreVert as NavIcon,
  PeopleOutlined as StudentsProgressIcon,
  PowerSettingsNew as LogoutIcon,
  Settings as SettingsIcon,
  SupervisorAccountOutlined as SupervisorAccountIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Link} from 'react-router-dom';

export const useStyles = makeStyles((theme) => ({
  NavIcon: {
    color: theme.palette.stemhero.blue,
  },
}));

export function SideBarThreeDotNavMenu({user}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [userSchool, setUserSchool] = React.useState({});
  const [userSponsor, setUserSponsor] = React.useState({});

  React.useEffect(() => {
    if (!user.school) return;
    const getUserSponsor = async () => {
      const userSchool = await Axios.get(`/api/school/${user.school}`);
      const userSponsor = await Axios.get(
        `/api/sponsor/${userSchool.data.sponsor}`,
      );
      setUserSponsor(userSponsor.data);
    };
    getUserSponsor();
  }, [user.school]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    localStorage.clear();
    // Workaround to prevent infinite loop error in react-microsoft-login component
    // https://github.com/alexandrtovmach/react-microsoft-login/issues/84
    const sessionStorage = window.sessionStorage;
    sessionStorage.clear();
  };

  return (
    <div>
      <IconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        aria-label="open navigation menu"
        color="primary"
        onClick={handleClick}
      >
        <NavIcon />
      </IconButton>
      {user && user.role === 'admin' ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          aria-modal="true"
        >
          <MenuItem button component={Link} to={'/admin'}>
            <ListItemIcon>
              <SupervisorAccountIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Admin Dashboard" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/fix"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fix errors (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <FixIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Fix" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/collaborate"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Collaborate (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <CollaborateIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Collaborate" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/guide"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Teacher resources (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <TeacherResourcesIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Teacher resources" />
          </MenuItem>
          <MenuItem button onClick={logout} component={Link} to={'/'}>
            <ListItemIcon>
              <LogoutIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </MenuItem>
        </Menu>
      ) : user && user.role === 'teacher' ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          aria-modal="true"
        >
          <MenuItem
            button
            onClick={handleClose}
            component={Link}
            to={'/teacher/classrooms'}
          >
            <ListItemIcon>
              <SettingsIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Add classes" />
          </MenuItem>
          <MenuItem
            button
            onClick={handleClose}
            component={Link}
            to={'/teacher/students'}
          >
            <ListItemIcon>
              <StudentsProgressIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Student Progress" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/fix"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fix errors (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <FixIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Fix errors" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/collaborate"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Collaborate (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <CollaborateIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Collaborate" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/guide"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Teacher resources (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <TeacherResourcesIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Teacher resources" />
          </MenuItem>
          {userSponsor && userSponsor.finalProjectUrl ? (
            <MenuItem
              button
              component="a"
              href={userSponsor.finalProjectUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Upload final projects (opens in new window)"
              onClick={handleClose}
            >
              <ListItemIcon>
                <FinalProjectUploadIcon style={{color: 'black'}} />
              </ListItemIcon>
              <ListItemText primary="Upload final projects" />
            </MenuItem>
          ) : null}
          <MenuItem button onClick={logout} component={Link} to={'/'}>
            <ListItemIcon>
              <LogoutIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          aria-modal="true"
        >
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/fix"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fix errors (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <FixIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Fix errors" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/collaborate"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Collaborate (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <CollaborateIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Collaborate" />
          </MenuItem>
          <MenuItem
            button
            component="a"
            href="https://meterhero.com/guide"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Teacher resources (opens in new window)"
            onClick={handleClose}
          >
            <ListItemIcon>
              <TeacherResourcesIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Teacher resources" />
          </MenuItem>
          <MenuItem button onClick={logout} component={Link} to={'/'}>
            <ListItemIcon>
              <LogoutIcon style={{color: 'black'}} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </MenuItem>
        </Menu>
      )}
    </div>
  );
}

SideBarThreeDotNavMenu.prototype = {
  user: PropTypes.object.isRequired,
};
